export const groupNamesMap: Record<string, string> = {
  RETAGUARDA_DE_LOJA: "Retaguarda de Loja",
  TI: "TI",
  FISCAL: "Fiscal",
  FINANCEIRO: "Financeiro",
  CONCILIACAO: "Conciliação",
  CRM: "CRM",
  PLANEJAMENTO_COMERCIAL: "Planejamento Comercial",
  RECURSOS_HUMANOS: "RH",
  ETIQUETA_REMARCADOS: "Etiqueta Remarcados",
  REMARCACAO_DE_PRECO: "Remarcação de Preço",
};
